import * as React from 'react';
import Header from '../Header';
import { YEAR_DECADE_COUNT } from '.';
import PanelContext from '../../PanelContext';
function YearHeader(props) {
    const { prefixCls, generateConfig, viewDate, onPrevDecade, onNextDecade, onDecadeClick } = props;
    const { hideHeader } = React.useContext(PanelContext);
    if (hideHeader) {
        return null;
    }
    const headerPrefixCls = `${prefixCls}-header`;
    const yearNumber = generateConfig.getYear(viewDate);
    const startYear = Math.floor(yearNumber / YEAR_DECADE_COUNT) * YEAR_DECADE_COUNT;
    const endYear = startYear + YEAR_DECADE_COUNT - 1;
    return (<Header {...props} prefixCls={headerPrefixCls} onSuperPrev={onPrevDecade} onSuperNext={onNextDecade}>
      <button type="button" onClick={onDecadeClick} className={`${prefixCls}-decade-btn`}>
        {startYear}-{endYear}
      </button>
    </Header>);
}
export default YearHeader;
